import { CategoryDto } from '../../dto/categories/categorydto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';

export interface CategoriesRequest extends APIRequest
{
    getCategoriesRequest(): CategoryDto;
}

export class CategoriesRequestImpl extends APIRequestDtoImpl implements CategoriesRequest
{
    constructor(private categoryData: CategoryDto)
    {
        super();
    }

    getCategoriesRequest(): CategoryDto
    {
        return this.categoryData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/categories/categoriesrequest.tsx